import Vue from 'vue'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

const configEl = document.getElementById('bu-app-config')
const context = configEl && configEl.dataset.context ? configEl.dataset.context : 'nocontext'

// V6
// import bugsnag from '@bugsnag/js'
// import bugsnagVue from '@bugsnag/plugin-vue'
// const bugsnagClient = bugsnag('3695854b78e763cdda94656eb20de911')
// bugsnagClient.use(bugsnagVue, Vue)
// To verify that your integration is working, call notify() in your application.
// An error should appear in your dashboard after you refresh this window.
// bugsnagClient.notify(new Error('Test error'))

// V7
Bugsnag.start({
  apiKey: '3695854b78e763cdda94656eb20de911',
  plugins: [new BugsnagPluginVue()],
  collectUserIp: false,
  releaseStage: context,
})

Bugsnag.getPlugin('vue').installVueErrorHandler(Vue)
